import Upload from './Upload';
export { Upload };
export default Upload;
